export default __webpack_public_path__ + "static/media/mock-map.39eb908b.svg";